import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'formatDate'
})

export class FormatDatePipe implements PipeTransform {
  constructor(
    private translate: TranslateService
  ) { }

  transform(value: any, format: string): string {
    const defLang = this.translate.getDefaultLang();
    moment.locale(defLang);
    return moment(value).format(format);
  }
}


// WEBPACK FOOTER //
// ./src/pipes/format-date.pipe.ts